import { z } from 'zod';

import { t } from '../i18n/validation.js';

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(6, t('validation.password.currentMinLength')),
    newPassword: z.string().min(6, t('validation.password.newMinLength')),
    confirmPassword: z.string().min(6, t('validation.password.confirmMinLength')),
  })
  .refine((values) => values.newPassword === values.confirmPassword, {
    path: ['confirmPassword'],
    message: t('validation.password.doNotMatch'),
  });

export type ChangePasswordForm = z.infer<typeof changePasswordSchema>;
